import firebase from 'firebase/app'

import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'

// const config = {
//   apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
//   authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
//   databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
//   projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
//   storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
//   messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID
// }

// prod
const config = {
  apiKey: 'AIzaSyDLpUWuUyVbYBByHUSa-IYMqyokogWub5s',
  authDomain: 'minna-ai.firebaseapp.com',
  databaseURL: 'https://minna-ai.firebaseio.com',
  projectId: 'minna-ai',
  storageBucket: 'minna-ai.appspot.com',
  messagingSenderId: '101979147145'
}
const api = 'https://us-central1-minna-ai.cloudfunctions.net'
// // const api = 'http://localhost:5000/minna-ai/us-central1'

// dev
// const config = {
//   apiKey: 'AIzaSyB6kAU9yFnGAl7tmEJqDIWevWtnWBWYSE8',
//   authDomain: 'minna-ai-dev.firebaseapp.com',
//   databaseURL: 'https://minna-ai-dev.firebaseio.com',
//   projectId: 'minna-ai-dev',
//   storageBucket: 'minna-ai-dev.appspot.com',
//   messagingSenderId: '661796007099'
// }
// // const api = 'http://localhost:5000/minna-ai-dev/us-central1'
// const api = 'https://us-central1-minna-ai-dev.cloudfunctions.net'

const firebaseApp = firebase.initializeApp(config)

const storage = firebaseApp.storage()
const auth = firebaseApp.auth()
const firestore = firebaseApp.firestore()

export default firebaseApp.firestore()
// export {storage}
export { firestore, firebase, storage, auth, api }
